import React from 'react';
import { useSelector } from 'react-redux';
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
} from '@gc-npm/components.text';
import Price, { PRICE_SIZE } from '@gc-npm/components.price';
import Spin from '@gc-npm/components.spin';

const ShoppingCartBottom = ({
  legalText,
  legalTextNoClte,
  prices,
  isLoading,
}) => {
  const {
    price,
    promoPrice,
    instalationPrice,
    instalationPromoPrice,
  } = prices;

  const permanence = useSelector((state) => state.UI.permanence);
  const userType = useSelector((state) => state.main?.context?.userType);

  return (
    <div className="ShoppingCartBottom">
      {instalationPrice && (
        <div className="fee">
          <div className="">
            <TextInfo
              text="Pago único"
              kind={TEXT_KIND.PARAGRAPH}
              color={TEXT_COLOR.GREY6}
              size={TEXT_SIZE.BODY1}
              align={TEXT_ALIGN.LEFT}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
          </div>

          {!isLoading && (
            <div className="price">
              <Price
                price={instalationPromoPrice || instalationPrice}
                color={TEXT_COLOR.MOVISTAR_BLACK}
                currency="€"
                size={PRICE_SIZE.XS}
                fontType={TEXT_FONT_WEIGHT.BOLD}
              />
            </div>
          )}
        </div>
      )}
      <div className="fee">
        <div className="">
          <TextInfo
            text="Cuota mensual"
            kind={TEXT_KIND.PARAGRAPH}
            color={TEXT_COLOR.GREY6}
            size={TEXT_SIZE.BODY1}
            align={TEXT_ALIGN.LEFT}
            fontType={TEXT_FONT_WEIGHT.BOLD}
          />
        </div>
        {isLoading && (
          <div className="spinnnerWrapper">
            <div className="Spin loading">
              <Spin operation="loading" />
            </div>
          </div>
        )}
        {!isLoading && (
          <div className="price">
            <Price
              price={promoPrice || price}
              color={TEXT_COLOR.MOVISTAR_BLACK}
              currency="€"
              quote="mes"
              size={PRICE_SIZE.XS}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
          </div>
        )}
      </div>
      {!isLoading && promoPrice && (
        <div className="notPromoted">
          <TextInfo
            text="Sin promoción"
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.GREY5}
            size={TEXT_SIZE.CAPTION1}
            align={TEXT_ALIGN.LEFT}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
          <Price
            price={price}
            color={TEXT_COLOR.GREY5}
            currency="€"
            quote="mes"
            size={PRICE_SIZE.XS}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
        </div>
      )}
      <div className="infoTexts">
        <div>
          <TextInfo
            text={(userType && userType !== '') ? legalText : legalTextNoClte}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.GREY5}
            size={TEXT_SIZE.BODY1}
            align={TEXT_ALIGN.LEFT}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
          <TextInfo
            text={permanence}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.GREY5}
            size={TEXT_SIZE.BODY1}
            align={TEXT_ALIGN.LEFT}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
        </div>
      </div>
      <style jsx>
        {`
          .ShoppingCartBottom {
            margin-bottom: 3rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .spinnnerWrapper {
              height: 2rem;
              display: flex;
              position: relative;
              flex-direction: row;
              justify-content: center;
              align-items: center;
            }
            .fee {
              width: 100%;
              display: grid;
              grid-template-columns: 3fr 1fr;
              align-items: end;
              padding-bottom: 0.5rem;
              row-gap: 5px;
              .price {
                justify-self: end;
              }
            }
            .notPromoted {
              display: flex;
              gap: 0.5rem;
            }
            .infoTexts {
              display: flex;
              flex-direction: column;
            }
          }
          @media screen and (min-width: 768px) {
            .ShoppingCartBottom {
              margin-bottom: 0rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ShoppingCartBottom;
